module.exports = __webpack_public_path__ + "img/3.1976a055.png";